import { createFileRoute } from '@tanstack/react-router';
import { NovoProdutorView } from '@/modules/agronomia/components/NovoProdutorView';

// Tela · Cadastro de novo produtor (mobile, full-bleed).
export const Route = createFileRoute('/_authed/agronomia_/novo-produtor')({
  component: NovoProdutorView,
});
